var exports = {
  "hZ": "trigger__MB41NP",
  "h4": "hideDragHandler__v3IQX7",
  "_U": "mouseTrigger__tUK8VL",
  "XE": "buttonTrigger__9357HA",
  "jl": "touchEnabled__qSLhOW",
};

module.exports = exports;
